import React from 'react';
import './HoneypotField.css';

interface HoneypotFieldProps {
  onChange: (value: string) => void;
  value: string;
}

export default class HoneypotField extends React.Component<HoneypotFieldProps> {
  render() {
    return (
      <div className="honeypot-field-wallet-address">
        <input
          type="text"
          name="walletAddress"
          tabIndex={-1}
          autoComplete="off"
          value={this.props.value}
          onChange={(e) => this.props.onChange(e.target.value)}
          aria-hidden="true"
        />
      </div>
    );
  }
} 